import { Location } from '@angular/common';
import { AfterViewInit, Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { AREA_TYPES, IArea, IBooth, ILinkAreaSettings } from '@sv/interfaces';
import { ShepherdService } from 'angular-shepherd';
import { AreaAnalyticsService } from 'src/app/_services/_analytics/area-analytics.service';
import { BoothAnalyticsService } from 'src/app/_services/_analytics/booth-analytics.service';
import { TicketcodeAuthService } from 'src/app/_services/_auth/ticketcode-auth.service';
import { CustomAppService } from 'src/app/_services/_content/customApp.service';
import { BoothService } from 'src/app/_services/_content/_TradeFair/booth.service';
import { TradefairService } from 'src/app/_services/_content/_TradeFair/tradefair.service';
import { TutorialService } from 'src/app/_services/_tutorial/tutorial.service';
import { BbbAreaComponent } from '../areas/bbb-area/bbb-area.component';
import { DownloadAreaComponent } from '../areas/download-area/download-area.component';
import { HtmlAreaComponent } from '../areas/html-area/html-area.component';
import { OpenspaceAreaComponent } from '../areas/openspace-area/openspace-area.component';
import { PdfAreaComponent } from '../areas/pdf-area/pdf-area.component';
import { VideoAreaComponent } from '../areas/video-area/video-area.component';
@Component({
  selector: 'app-booth-overview',
  templateUrl: './booth-overview.component.html',
  styleUrls: ['./booth-overview.component.scss']
})
export class BoothOverviewComponent implements OnInit, OnDestroy, AfterViewInit {
  AREA_TYPES: AREA_TYPES;
  headlineColor = 'blue';
  document: Document;
  screen: Screen;

  isReadMore = true;

  constructor(
    private boothService: BoothService,
    private location: Location,
    @Inject(MAT_DIALOG_DATA) public data: { boothId: string; showExpoTag: boolean; currentRoute: ActivatedRoute },
    private dialogRef: MatDialogRef<BoothOverviewComponent>,
    private dialog: MatDialog,
    private areaAnalyticsService: AreaAnalyticsService,
    private authService: TicketcodeAuthService,
    private boothAnalyticsService: BoothAnalyticsService,
    private shepherdService: ShepherdService,
    private tutorialService: TutorialService,
    private customAppService: CustomAppService,
    private router: Router,
    private fairService: TradefairService
  ) {}

  loaded = false;
  boothId: string;
  booth: IBooth;

  sloganColor = '';

  mobile = false;
  @HostListener('window:resize', [])
  onResize() {
    const width = window.innerWidth;
    this.mobile = width < 699;
    if (this.mobile) {
      this.customAppService.setBoothActive(true);
    } else {
      this.customAppService.setBoothActive(false);
    }
  }

  async ngOnInit(): Promise<void> {
    this.mobile = document.documentElement.clientWidth < 699;
    if (this.mobile) {
      this.customAppService.setBoothActive(true);
    }
    this.boothId = this.data.boothId;
    if (this.boothId === undefined) {
      this.location.back();
    }
    try {
      this.booth = await this.boothService.getBoothWithAreas(this.boothId);
    } catch (error) {
      console.log(error.error.message);
      this.location.back();
    }
    const colors = this.booth.settings.colors;
    if (colors) {
      this.sloganColor = colors.slogan ?? 'grey';
    } else {
      this.sloganColor = 'grey';
    }
    if (this.booth.settings.learnMoreButton === undefined) {
      this.booth.settings.learnMoreButton = 'Learn More';
    }
    if (this.booth.settings.hideButton === undefined) {
      this.booth.settings.hideButton = 'Hide';
    }

    this.document = document;
    this.screen = screen;

    this.loaded = true;
  }

  ngAfterViewInit(): void {
    if (sessionStorage.getItem('tutorial') === null && sessionStorage.getItem('fair') === null) {
      this.shepherdService.addSteps(this.tutorialService.getFairSteps());
      this.shepherdService.tourObject.addStep(this.tutorialService.getLastStep());

      this.shepherdService.start();
    }
  }

  showText() {
    this.isReadMore = !this.isReadMore;
  }

  openArea(area: IArea) {
    switch (area.areaType) {
      case AREA_TYPES.DOWNLOADS:
        this.dialog.open(DownloadAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.BBB:
        this.dialog.open(BbbAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.VIDEOS:
        this.dialog.open(VideoAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.OPEN_SPACE:
        this.dialog.open(OpenspaceAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.HTML:
        this.dialog.open(HtmlAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.PDF:
        this.dialog.open(PdfAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.SLIDO:
        this.dialog.open(OpenspaceAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.YOUTUBE:
        this.dialog.open(OpenspaceAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.CALENDLY:
        this.dialog.open(OpenspaceAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.LINK:
        window.open((area.settings as ILinkAreaSettings).link, '_blank');
        this.areaAnalyticsService.startDuration(this.boothId);
        this.areaAnalyticsService.newAreaView(area);
        break;
      case AREA_TYPES.WEBSITE:
        this.dialog.open(OpenspaceAreaComponent, {
          data: { area, settings: area.settings, colors: this.booth.settings.colors },
          width: '100%',
          panelClass: 'boothDialogArea'
        });
        break;
      case AREA_TYPES.EMAIL:
        window.open((area.settings as ILinkAreaSettings).link, '_blank');
        this.areaAnalyticsService.startDuration(this.boothId);
        this.areaAnalyticsService.newAreaView(area);
        break;
      case AREA_TYPES.LINKEDIN:
        window.open((area.settings as ILinkAreaSettings).link, '_blank');
        this.areaAnalyticsService.startDuration(this.boothId);
        this.areaAnalyticsService.newAreaView(area);
        break;
      default:
        console.log('area not implemented');
        return;
    }
    this.areaAnalyticsService.startDuration(this.boothId);
  }

  goBack() {
    this.dialogRef.close();
  }

  routeToExpo() {
    this.fairService.setFair(this.booth.tradefairId);
    this.router.navigate([this.booth.tradefairId], {
      relativeTo: this.data.currentRoute,
      queryParamsHandling: 'merge',
      queryParams: { boothId: this.boothId }
    });
  }

  ngOnDestroy() {
    this.customAppService.setBoothActive(false);
    const url = window.location.href;
    const useragent = navigator.userAgent;
    if (!url.includes('cloudfront.net')) {
      if (localStorage.getItem('dataUsage') === 'true') {
        const user = this.authService.decodeToken();
        if (user) {
          this.boothAnalyticsService.newBoothView(user._id);
        }
      } else {
        this.boothAnalyticsService.newBoothView();
      }
    }
    if (sessionStorage.getItem('tutorial') === null) {
      sessionStorage.setItem('fair', 'false');
      this.shepherdService.complete();
    }
  }
}
